const data = {
    spm: {
        baseData: {
            motorAccountHolder: {
                ukResidentSinceBirth: null,
                fullUkLicence: null,
                isMaritalStatusRequired: true
            }
        },
        lobData: {
            privateMotor: {
                coverables: {
                    spmDrivers: [
                        {
                            hasRCECover: null,
                            hasPersonalAccidentCover: null,
                            ukResidentSinceBirth: null,
                            driverLicenseScope: null,
                            driverLicenseYears: null,
                            hasAccessToOtherVehicles: null,
                            isInsuranceDeclined: null,
                            hasMotorClaims: null,
                            hasMotorConvictions: null,
                            hasNonMotoringConvictions: null,
                            isMainUserOfVehicle: null,
                            person: {}
                        }
                    ],
                    spmVehicle: {
                        hasModifications: null,
                        hasFixedPrice: null,
                        requestedVolExcess: null,
                        ncdYears: null,
                        hasLegalCover: null,
                        hasSelectedLegalOnEssential: null,
                        hasBreakdownCover: null,
                        hasKeyProtection: null,
                        hasSelectedKeyProtectionOnEssential: null,
                        hasVandalismPromise: null,
                        payByInstalments: null,
                        vehicleUse: null,
                        vehicleOwnerType: null
                    },
                    hasAdditionalDrivers: null
                }
            }
        }
    },
    sph: {
        lobData: {
            privateHome: {
                coverables: {
                    propertyDetails: {
                        contentsTotal: {
                            amount: null,
                            originalAmount_Ext: null
                        },
                        contentsCoverValue: null,
                        rebuildCost: {},
                        contentsExcess: null,
                        buildingsExcess: null,
                        moreThanHalfRoofFlat: null,
                        hasSheCover: null,
                        moreThanQuarterRoofFlat: null,
                        isMainResidence: null,
                        contentsSumInsured: null,
                        hasFixedPrice: null,
                        hasContentsAccidentCover: null,
                        hasBuildingsAccidentCover: null,
                        unspecifiedItemsCover: null,
                        hasLegalCover: null
                    },
                    morePropertyDetails: {
                        hasSubsidenceHeaveLandslip: null,
                        hasFloodingAtProperty: null,
                        hasBusinessUse: null
                    },
                    otherInfoAboutYou: {
                        claims: [],
                        hasHomeClaims: null,
                        currentPaymentType: null,
                        hasPromoCode: null,
                        ownOtherProperties: null
                    },
                    hasJointPolicyHolder: null
                }
            }
        }
    }
};

export default data;
